module.exports = __webpack_public_path__ + "static/media/BC3.d902d8cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/BC3.png
// module id = 378
// module chunks = 0